export const API_BASE = process.env.REACT_APP_API_URL || window.__APP_API_BASE__ || 'http://localhost:4000';

const SENSITIVE_UPLOAD_DIRS = new Set([
  'checkin',
  'documentos',
  'proveedores',
  'camareras',
  'profiles',
  'comprobantes',
]);

const getAuth = () => {
  try { return JSON.parse(localStorage.getItem('auth') || '{}'); } catch { return {}; }
};

const normalizeUrl = (url) => {
  if (!url) return '';
  return String(url)
    .replace(/^http:\/\/127\.0\.0\.1:4000/i, API_BASE)
    .replace(/^http:\/\/localhost:4000/i, API_BASE);
};

export const apiUrl = (path = '') => normalizeUrl(`${API_BASE}${path.startsWith('/') ? path : `/${path}`}`);

export const assetUrl = (path = '') => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return normalizeUrl(path);
  return normalizeUrl(`${API_BASE}${path.startsWith('/') ? path : `/${path}`}`);
};

export const secureAssetUrl = (path = '') => {
  const full = assetUrl(path);
  if (!full) return '';
  const rel = String(path || '').replace(/^https?:\/\/[^/]+/i, '');
  const seg = rel.replace(/^\/+/, '').split('/')[1] || rel.replace(/^\/+/, '').split('/')[0] || '';
  if (!SENSITIVE_UPLOAD_DIRS.has(seg)) return full;

  const token = getAuth()?.appToken;
  if (!token) return full;
  const u = new URL(full, window.location.origin);
  u.searchParams.set('appToken', token);
  return u.toString();
};
